import { MyAccountPage } from './pages/MyAccountPage';

export const myAccountRoutes = {
  path: 'my-account',
  element: <MyAccountPage />,
};
